import { render } from "./process.vue?vue&type=template&id=e3dbca82&scoped=true"
import script from "./process.vue?vue&type=script&lang=js"
export * from "./process.vue?vue&type=script&lang=js"

import "./process.vue?vue&type=style&index=0&id=e3dbca82&lang=scss&scoped=true"
import "./process.vue?vue&type=style&index=1&id=e3dbca82&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3dbca82"]])

export default __exports__